import { forwardRef, useEffect, useState } from 'react';
import FullCalendar, { EventClickArg, MoreLinkArg } from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import './calendar.css';
import Event from './Event';
import {
  dayCellContent,
  dayHeaderContent,
  EventInfo,
  MoreEvents,
} from './Utils';
import { CALENDAR_VIEW, CalendarEvent } from '../types';

interface CalendarProps {
  view: CALENDAR_VIEW;
  width: number;
  events: CalendarEvent[];
}

const Calendar = forwardRef<any, CalendarProps>(
  ({ view, width, events }, ref) => {
    const [selectedEvent, setSelectedEvent] = useState<EventClickArg | null>(
      null
    );
    const [moreEventsClick, setMoreEventsClick] = useState<MoreLinkArg | null>(
      null
    );

    useEffect(() => {
      setSelectedEvent(null);
      setMoreEventsClick(null);
    }, [view]);

    return (
      <div className="h-full">
        <EventInfo
          clickedEvent={selectedEvent}
          closeHandler={() => setSelectedEvent(null)}
        />
        <MoreEvents
          clickedEvent={moreEventsClick}
          closeHandler={() => setMoreEventsClick(null)}
        />
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin]}
          initialView={view}
          headerToolbar={false}
          height={'100%'}
          events={events}
          eventColor="transparent"
          eventBorderColor={'#0000FF'}
          dayCellContent={(info) => dayCellContent({ info, view, width })}
          eventContent={(eventInfo) => (
            <Event
              eventContent={eventInfo}
              width={width}
              view={view}
              active={eventInfo.event.id === selectedEvent?.event.id}
            />
          )}
          eventClick={setSelectedEvent}
          dayHeaderContent={(info) => dayHeaderContent({ info, view, width })}
          allDaySlot={false}
          slotLabelFormat={{
            timeStyle: 'short',
            hour12: false,
          }}
          firstDay={1} // Start week from monday
          ref={ref}
          dayCellClassNames={`${width === 3 ? 'h-28' : 'h-12'}`}
          dayMaxEvents={2} // show "more" button
          moreLinkClassNames="text-grey-50 font-medium text-xs"
          moreLinkClick={setMoreEventsClick}
          eventMaxStack={1}
          showNonCurrentDates={false}
          nowIndicator
        />
      </div>
    );
  }
);

export default Calendar;
